interface SidebarMobileOverlayProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Backdrop shown behind an open mobile sidebar drawer. Shared by
 * AdminSidebar and SuperAdminSidebar (pure extraction — see
 * SidebarAccountMenu's javadoc for why this lives here instead of being
 * duplicated per sidebar).
 */
export default function SidebarMobileOverlay({ isOpen, onClose }: SidebarMobileOverlayProps) {
  if (!isOpen) return null;
  return <div className="lg:hidden fixed inset-0 z-30 bg-black/50" onClick={onClose} />;
}
